import { Helmet } from 'react-helmet-async';
import manikchandLogo from '../../assets/images/manikchand_Logo.svg';

const LoginPageHelmet = () => (
  <Helmet>
    {/* Title */}
    <title>Namasteji Manikchand Login</title>

    {/*  Meta Description  */}
    <meta
      name='description'
      content='Login to your Namasteji Manikchand account easily. Access the official Manikchand login page to manage your profile, explore products, and enjoy a seamless experience with India’s trusted pan masala brand.'
    />

    {/*  Keywords */}
    <meta
      name='keywords'
      content='How to login to Namasteji Manikchand,
          Namasteji login,
          Manikchand login page,
          Login to Namasteji Manikchand,
          Namasteji Manikchand account login'
    />

    {/*  Canonical URL */}
    <link rel='canonical' href='https://globalmanikchand.in/login' />

    {/*  Open Graph (Facebook, WhatsApp, Instagram) */}
    <meta property='og:type' content='website' />
    <meta property='og:title' content='Login to Namasteji' />
    <meta
      property='og:description'
      content='Access your Namasteji Manikchand account through the official login page. Sign in securely to manage your details, explore premium pan masala products, and stay connected with the brand you trust.'
    />
    <meta property='og:url' content='https://globalmanikchand.in/login' />
    <meta property='og:image' content={window.location.origin + manikchandLogo} />
    <meta property='og:site_name' content='Manikchand Log in' />
    <meta property='og:locale' content='en_IN' />

    {/*  Twitter Card */}
    <meta name='twitter:card' content={window.location.origin + manikchandLogo} />
    <meta name='twitter:title' content='Login to Namasteji' />
    <meta
      name='twitter:description'
      content='Access your Namasteji Manikchand account through the official login page. Sign in securely to manage your details, explore premium pan masala products, and stay connected with the brand you trust.'
    />
    <meta name='twitter:image' content={window.location.origin + manikchandLogo} />
    <meta name='twitter:site' content='@NamastejiManikchand' />
  </Helmet>
);

export default LoginPageHelmet;
